import { render, staticRenderFns } from "./indexOwnerRoom.vue?vue&type=template&id=0862e2b2&scoped=true"
import script from "./indexOwnerRoom.vue?vue&type=script&lang=js"
export * from "./indexOwnerRoom.vue?vue&type=script&lang=js"
import style0 from "./indexOwnerRoom.vue?vue&type=style&index=0&id=0862e2b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0862e2b2",
  null
  
)

export default component.exports